module.exports = __webpack_public_path__ + "static/media/ic_info_red.772692a5.svg";